import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Thermometer, ArrowRight } from "lucide-react";

export default function IntakeBand() {
  return (
    <section
      data-testid="intake-band-section"
      aria-labelledby="intake-band-heading"
      className="relative overflow-hidden"
    >
      <div className="container-page py-10 sm:py-12">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.5, ease: "easeOut" }}
          className="relative overflow-hidden rounded-3xl border border-aqua/20 bg-brand-gradient p-6 text-white shadow-lift sm:p-9"
        >
          <div className="absolute -right-10 -top-10 h-48 w-48 rounded-full bg-aqua/30 blur-3xl" aria-hidden="true" />
          <div className="absolute -bottom-14 -left-10 h-48 w-48 rounded-full bg-sun/15 blur-3xl" aria-hidden="true" />

          <div className="relative flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-center">
            <div className="max-w-2xl">
              <span className="pill-dark">
                <Thermometer className="h-3 w-3 text-sun" />
                Intake flow
              </span>
              <h2
                id="intake-band-heading"
                className="mt-3 font-display text-2xl font-bold leading-tight tracking-tight text-white sm:text-3xl md:text-[2rem]"
              >
                AC not cooling? Start a service request.
              </h2>
              <p className="mt-2 max-w-xl text-sm text-white/80 sm:text-base">
                This sample intake flow shows how a homeowner can describe the
                issue clearly so the contractor knows what&rsquo;s needed before
                the callback.
              </p>
            </div>

            <div className="flex shrink-0 flex-col items-stretch gap-2 sm:items-end">
              <Link
                to="/request-service"
                data-testid="intake-band-cta"
                className="group inline-flex items-center justify-center gap-2 rounded-full bg-sun px-6 py-3 text-sm font-semibold text-navy-deep shadow-sunGlow transition-transform hover:scale-[1.02]"
              >
                Start Service Request
                <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
              </Link>
              <p className="text-[11px] text-white/60 sm:text-right">
                Demo intake flow &mdash; no real emergency dispatch.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
